import clsx from 'clsx';

export const listWrapperClassNames =
  'relative before:absolute before:bottom-[2px] before:left-0 before:h-[2px] before:w-full before:bg-stroke';

export const listClassNames = {
  default: 'relative flex gap-x-12 overflow-x-auto scrollbar-hide pb-1',
  dense: 'gap-x-4'
};

export const tabClassNames = {
  default: clsx(
    'relative shrink-0 select-none border-b border-transparent pb-1 font-medium text-muted outline-none',
    "after:invisible after:absolute after:-bottom-[3px] after:left-0 after:h-[2px] after:w-full after:bg-primary after:content-['']",
    'data-[selected]:text-primary data-[selected]:after:visible'
  ),
  size: {
    small: 'text-sm',
    default: 'text-base'
  }
};
